import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Badge } from "../ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";
import { Trash2 } from "lucide-react";
import NumF from "./NumF";

export default function ExtraRow({ e, onChange, onRemove }) {
  return (
    <div className="border border-[#E5E2DC] rounded-xl p-3 space-y-2 bg-white mb-2" data-testid={`extra-${e.id}`}>
      <div className="flex items-center justify-between">
        <Badge className="bg-[#8A9A86] text-white text-[10px]">Extra</Badge>
        <button onClick={onRemove} className="w-8 h-8 rounded-lg text-[#D9534F] hover:bg-red-50 flex items-center justify-center">
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
      <Input value={e.description} onChange={(ev) => onChange({ description: ev.target.value })}
        placeholder="Omschrijving" className="h-10 rounded-lg" data-testid={`extra-desc-${e.id}`} />
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        <NumF label="Aantal" step="0.01" value={e.quantity} onChange={(v) => onChange({ quantity: v })} testId={`extra-qty-${e.id}`} />
        <div>
          <Label className="text-xs">Eenheid</Label>
          <Select value={e.unit} onValueChange={(v) => onChange({ unit: v })}>
            <SelectTrigger className="h-10 mt-1 rounded-lg"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="m2">m²</SelectItem><SelectItem value="lm">lm</SelectItem>
              <SelectItem value="piece">stuk</SelectItem><SelectItem value="hour">uur</SelectItem>
              <SelectItem value="fixed">forfait</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <NumF label="Prijs (excl.)" step="0.01" value={e.unit_price} onChange={(v) => onChange({ unit_price: v })} testId={`extra-price-${e.id}`} />
      </div>
      <div className="text-[11px] text-[#5D7259]">BTW wordt automatisch berekend volgens project-tarief.</div>
    </div>
  );
}
